
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#52A728","d":"M67.358 21.998H19.734c-1.622 0-2.894 1.416-2.64 2.954l4.136 26.673c.19 1.261 1.304 2.184 2.64 2.184h39.32c1.305 0 2.45-.922 2.64-2.184l4.136-26.673c.255-1.538-.986-2.954-2.608-2.954z"}}),_c('path',{attrs:{"fill":"#A8D393","d":"M26.893 67.5c3.04 0 5.503-2.383 5.503-5.322 0-2.94-2.464-5.323-5.503-5.323-3.04 0-5.504 2.383-5.504 5.323 0 2.939 2.464 5.322 5.504 5.322zm33.689 0c3.04 0 5.504-2.383 5.504-5.322 0-2.94-2.464-5.323-5.504-5.323-3.04 0-5.503 2.383-5.503 5.323 0 2.939 2.464 5.322 5.503 5.322zM28.706 16.4H12.259c-1.241 0-2.259-.985-2.259-2.185 0-1.2 1.018-2.215 2.29-2.215h16.448c1.24 0 2.258.985 2.258 2.184 0 1.2-1.018 2.215-2.29 2.215z"}})])
          )
        }
      }
    